import * as types from './mutation-types'

export default {
    initializestate(state) {
        state.initialized = true
    },
    [types.ACOUNTS](state, value) {
        state.acounts = { ...state.acounts, ...value }
    },
    [types.SET_GAMEID] (state, value) {
        state.gameid = value
    }
}